import { Checkbox as MuiCheckbox, styled } from '@mui/material';

export const Checkbox = styled(MuiCheckbox)(() => ({
	svg: {
		width: '24px',
		height: '24px',
	},
}));
